import uabsRotas from './uabs/UabsRotas'
import fornecedorRotas from './fornecedores/FornecedorRotas'
import gestoresRotas from './gestores/GestoresRotas'
import gerentesRotas from './gerentes/GerentesRotas'
import financeiroRotas from './financeiro/FinanceiroRotas'
import apoiosRotas from './apoios/ApoiosRotas'
import adminRotas from './admin/AdminRotas'


export default {
    path: 'sgtec',
    name: 'Sgtec',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        uabsRotas,
        fornecedorRotas,
        gestoresRotas,
        gerentesRotas,
        financeiroRotas,
        apoiosRotas,
        adminRotas,
        
    ]
}
